// テンプレート管理画面から案内する Today website の事例ページ
// 先方依頼: docs/external/20260910ver2(テンプレ機能修正依頼).pdf P2 ②

// ノートテンプレートの事例ページ。
export const NOTE_TEMPLATE_EXAMPLE_URL = 'https://t-today.jp/note-templates/'

// 目標テンプレートの事例ページ。
export const MANDALA_GOAL_TEMPLATE_EXAMPLE_URL = 'https://t-today.jp/action-goals/'
